import styled from "styled-components";

export const HeaderContainer = styled.div`
    *{
        user-select: none;
    }
    .header__block{
        width: 100%;
        position: fixed;
        top: 0;
        left : 0;
        background-color: #33363C;
        text-align: right;
        padding: 0px 10px 0px 0px;
        z-index: 999;
        transition: max-height 3s ease-in-out;
    }
    .profile__box{
        display: flex;
        align-items: center;
        justify-content: end;
    }
    .profile__icon{
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
    .profile__icon:hover path{
        stroke: #36BDBE;
    }
    .header__btn{
        padding: 10px 0px;
    }
    .header__btn:focus{
        outline: none;
    }
    .header_toggle_box{
        position: fixed;
        right: 0px;
        content: '';
        width: 85px;
        height: 40px;
        clip-path: polygon( 25.894% 15.854%,3.861% 1.25%,99.412% 1.25%,99.412% 98.75%,49.975% 98.75%,49.975% 98.75%,47.208% 98.276%,44.583% 96.902%,42.135% 94.704%,39.9% 91.756%,37.912% 88.133%,36.207% 83.909%,34.82% 79.159%,33.786% 73.958%,33.139% 68.38%,32.916% 62.5%,32.916% 36.14%,32.916% 36.14%,32.832% 33.387%,32.587% 30.726%,32.189% 28.181%,31.647% 25.78%,30.971% 23.549%,30.17% 21.513%,29.253% 19.7%,28.228% 18.135%,27.105% 16.844%,25.894% 15.854% );
        background-color: #33363C;
        border-radius: 0px;
        border: 1px solid #6A727C;
        color: #ffffff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 27px;
        transition: background-color 0.4s ease; 
    }
    .header_toggle_box:hover{
        background-color: #36BDBE;
    }
    .menu_left_column{
        justify-content: start;
        padding-left: 0px;
    }
    .menu_top_box{
        width: fit-content;
        height: 100%;
        display: flex;
    }
    .menu_button{
        height: 100%;
        min-width: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: transparent;
        border: none;
        border-radius: 0px;
        color: #ffffff;
    }
    .menu_button:focus{
        outline: none;
    }
    .menu_button:hover{
        outline: none;
        background-color: #36BDBE !important;
        color: #000000 !important;
        border: none !important;
    }
    .menu_button svg{
        width: 10px;
        height: 10px;
    }
    .menu_button .menu_icon{
        width: 30px !important;
        height: 30px !important;
    }
    .menu_button:hover svg{
        color: #000000 !important;
    }
    .menu_button:hover svg path{
        stroke: #000000;
    }
    .menu_button .anticon-down{
        margin-left: 5px;
        margin-top: 2px;
    }
    .menu_dropdown .ant-dropdown-menu-item:last-child:hover svg{
        color: #000000 !important;
    }
    .profile_main_block{
        display: flex;
        gap: 15px;
        align-items: center;
        justify-content: end;
    }
    .user_guide_box{
        display: flex;
        align-items: center;
    }
`;
